import CwLoadModules from '@customjs/module-loader.js';

const CwThemeFramework = {
    async generalFns() {
        const office = document.querySelector('.select-office');
        if (office) {
            this.loadLocations(office);
            office.addEventListener('change', () => this.loadLocations(office));
        }

        //(For Contact page Location Widget)
        const officeContact = document.querySelector('.select-office-contact');
        if (officeContact) {
            this.loadLocationsContact(officeContact);
            officeContact.addEventListener('change', () => this.loadLocationsContact(officeContact));
        }

        document.addEventListener("DOMContentLoaded", function() {
            const toggleSearch = document.querySelector(".header-search .icon-search");
            const searchContainer = document.querySelector(".header-search");

            if (toggleSearch && searchContainer) {
                toggleSearch.addEventListener("click", function() {
                    searchContainer.classList.toggle("search-open");
                });
            }
        });

        document.addEventListener('DOMContentLoaded', function () {
            var videoLinks = document.querySelectorAll('.cw_video_open_popup_customized');
    
            videoLinks.forEach(function (link) {
                link.addEventListener('click', function (event) {
                    event.preventDefault();
                });
            });
        });

        
        //Custom Audio Player
        document.addEventListener("DOMContentLoaded", function() {
            const audioPlayers = document.querySelectorAll('.audio-player');

            audioPlayers.forEach(player => {
                const audio = player.querySelector('.audio-element');
                const playPauseBtn = player.querySelector('.playPauseBtn');
                const progressBar = player.querySelector('.progress-bar');
                const progress = player.querySelector('.progress');
                const volumeIcon = player.querySelector('.volume-icon');
                const currentTimeDisplay = player.querySelector('.currentTime');
                const maxTimeDisplay = player.querySelector('.maxTime');
                let isDraggingProgress = false;

                audio.addEventListener('loadedmetadata', () => {
                    const duration = audio.duration;
                    maxTimeDisplay.textContent = formatTime(duration);
                });

                playPauseBtn.addEventListener('click', () => {
                    if (audio.paused) {
                        audio.play();
                    } else {
                        audio.pause();
                    }
                });

                audio.addEventListener('play', () => {
                    playPauseBtn.classList.remove('paused');
                });

                audio.addEventListener('pause', () => {
                    playPauseBtn.classList.add('paused');
                });

                progressBar.addEventListener('mousedown', (event) => {
                    isDraggingProgress = true;
                    updateProgress(event);
                });

                document.addEventListener('mousemove', (event) => {
                    if (isDraggingProgress) {
                        updateProgress(event);
                    }
                });

                document.addEventListener('mouseup', () => {
                    if (isDraggingProgress) {
                        isDraggingProgress = false;
                    }
                });

                volumeIcon.addEventListener('click', () => {
                    if (audio.muted) {
                        audio.muted = false;
                        volumeIcon.classList.remove('muted');
                    } else {
                        audio.muted = true;
                        volumeIcon.classList.add('muted');
                    }
                });

                function updateProgress(event) {
                    const rect = progressBar.getBoundingClientRect();
                    const offsetX = event.clientX - rect.left;
                    const percentage = offsetX / rect.width;
                    const duration = audio.duration;
                    audio.currentTime = duration * percentage;
                }

                audio.addEventListener('timeupdate', () => {
                    const currentTime = audio.currentTime;
                    const duration = audio.duration;
                    const progressPercentage = (currentTime / duration) * 100;
                    progress.style.width = `${progressPercentage}%`;

                    currentTimeDisplay.textContent = formatTime(currentTime);
                });

                function formatTime(time) {
                    const minutes = Math.floor(time / 60);
                    const seconds = Math.floor(time % 60);
                    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
                }
            });
        });


    // Disable Bootstrap Accordion functionality
    const bootstrapAccordionTitles = document.querySelectorAll('.accordion .title');
    const bootstrapCollapseElements = document.querySelectorAll('.accordion .collapse');
    
    // Reset Bootstrap collapse elements
    bootstrapCollapseElements.forEach(collapse => {
        collapse.removeAttribute('data-bs-parent');
        collapse.removeAttribute('style');
        collapse.classList.remove('show', 'collapsing');
        collapse.style.cssText = '';
    });
    
    // Clone and replace Bootstrap titles
    bootstrapAccordionTitles.forEach(title => {
        const newTitle = title.cloneNode(true);
        title.parentNode.replaceChild(newTitle, title);
        
        // Remove Bootstrap data attributes but keep accessibility
        newTitle.removeAttribute('data-bs-toggle');
        newTitle.removeAttribute('data-bs-target');
        newTitle.removeAttribute('href');
        
        // Set initial state and make focusable
        newTitle.setAttribute('aria-expanded', 'false');
        newTitle.setAttribute('tabindex', '0');
        
        // Allow CSS to handle the click
        newTitle.addEventListener('click', function(e) {
            this.focus(); // Ensure focus for CSS :focus selector
        });
    });

    },

    /**
     * Load Locations
     */
    async loadLocations(locationID) {
        if (locationID) {
            CwLoadModules.modals().then((modals) => {
                const officeHours = new modals('.cw-modal');
                officeHours.init();
            });
            const apiURL = `/api/location/${locationID.value}/`;
            const officeBox = document.querySelector('.office-info');
            const officeMap = document.querySelector('.office-map');
            const officeHours = document.querySelector('.opening-hours');
            const officeTourModal = document.querySelector('.office-tour');
            const officeInfo = await fetch(apiURL);
            const officeDetails = await officeInfo.json();

            if (officeDetails.success) {
                const {
                    firmName,
                    directionURL,
                    mapURL,
                    city,
                    state,
                    zip,
                    location_address_1,
                    location_address_2,
                    phone,
                    email,
                    toll_free_number,
                    location_fax,
                    footer_map,
                    footer_map_mobile,
                    officeTour,
                    monday_hours,
                    tuesday_hours,
                    wednesday_hours,
                    thursday_hours,
                    friday_hours,
                    saturday_hours,
                    sunday_hours,
                    is_spanish,
                } = officeDetails.data;

                const directionLabel = is_spanish ? 'Direcciones' : 'Directions';
                const officeHoursLabel = is_spanish ? 'Horario de Oficina' : 'Office Hours';
                const firmNameHTML = firmName ? `<div class="firm-name">${firmName}</div>` : '';
                const address1HTML = location_address_1 ?
                    `<span>${location_address_1}</span><br>` :
                    '';
                const address2HTML = location_address_2 ?
                    `<span>${location_address_2}</span><br>` :
                    '';
                const phoneHTML = phone ?
                    `<div class="phone"><a href="tel:${phone}" class="btn btn-secondary btn-phone with-icon icon-phone ctm-no-swap" aria-label="${phone}"><span class="text">${phone}</span></a></div>` :
                    '';
                const emailHTML = email ?
                    `<a href="mailto:${email}" aria-label="Email Address">${email}</a>` :
                    '';
                const officeTourHTML = officeTour ? `<button class="cw-modal" data-cw-target="#officeTour" id="office-tour">360 Office Tour</button>` : '';
                const officeInfoButtons = `<div class="office-info__buttons">
                   <a id="directions" href="${directionURL}" target="_blank" aria-label="${directionLabel}">${directionLabel}</a>
                   <button class="cw-modal" data-cw-target="#hoursModal" id="office-hours">${officeHoursLabel}</button>
                   ${officeTourHTML}
               </div>`;

               const footerMapHTML = footer_map ?
                `<a href="${mapURL}" target="_blank" aria-label="Direction Link">
                    <img class="d-none d-xl-inline" src="${footer_map}" alt="${firmName}" />
                    <img class="d-xl-none" src="${footer_map_mobile}" alt="${firmName}" />
                </a>` :
                '';

                const address = `${firmNameHTML}
                <address>
                    ${address1HTML}
                    ${address2HTML}
                    <span>${city}, ${state} ${zip}</span><br>
                </address>
               ${phoneHTML}
               ${emailHTML}${officeInfoButtons}`;
               officeBox.innerHTML = address;
               officeMap.innerHTML = footerMapHTML;

                const mondayLabel = is_spanish ? 'Lunes' : 'Monday';
                const tuesdayLabel = is_spanish ? 'Martes' : 'Tuesday';
                const wednesdayLabel = is_spanish ? 'Miércoles' : 'Wednesday';
                const thursdayLabel = is_spanish ? 'Jueves' : 'Thursday';
                const fridayLabel = is_spanish ? 'Viernes' : 'Friday';
                const saturdayLabel = is_spanish ? 'Sábado' : 'Saturday';
                const sundayLabel = is_spanish ? 'Domingo' : 'Sunday';
                const mondayHoursHTML = monday_hours ?
                    `<tr><td class="day">${mondayLabel}</td><td class="time"><span>${monday_hours}</span></td></tr>` :
                    '';
                const tuesdayHoursHTML = tuesday_hours ?
                    `<tr><td class="day">${tuesdayLabel}</td><td class="time"><span>${tuesday_hours}</span></td></tr>` :
                    '';
                const wednesdayHoursHTML = wednesday_hours ?
                    `<tr><td class="day">${wednesdayLabel}</td><td class="time"><span>${wednesday_hours}</span></td></tr>` :
                    '';
                const thursdayHoursHTML = thursday_hours ?
                    `<tr><td class="day">${thursdayLabel}</td><td class="time"><span>${thursday_hours}</span></td></tr>` :
                    '';
                const fridayHoursHTML = friday_hours ?
                    `<tr><td class="day">${fridayLabel}</td><td class="time"><span>${friday_hours}</span></td></tr>` :
                    '';
                const saturdayHoursHTML = saturday_hours ?
                    `<tr><td class="day">${saturdayLabel}</td><td class="time"><span>${saturday_hours}</span></td></tr>` :
                    '';
                const sundayHoursHTML = sunday_hours ?
                    `<tr><td class="day">${sundayLabel}</td><td class="time"><span>${sunday_hours}</span></td></tr>` :
                    '';

                const hoursOffice = `<table>
                                <tbody>
                                ${mondayHoursHTML}
                                ${tuesdayHoursHTML}
                                ${wednesdayHoursHTML}
                                ${thursdayHoursHTML}
                                ${fridayHoursHTML}
                                ${saturdayHoursHTML}
                                ${sundayHoursHTML}
                                </tbody>
                            </table>`;

                // Hours Modal
                officeHours.innerHTML = hoursOffice;

                const officeTourData = `${officeTour}`;
                officeTourModal.innerHTML = officeTourData;
            }
        }
    },

    /**
    * Load Locations (For Contact page Location Widget)
    */
    async loadLocationsContact(contactLocationID) {
        if (contactLocationID) {
            CwLoadModules.modals().then((modals) => {
                const officeHours = new modals('.cw-modal');
                officeHours.init();
            });
            const apiURL = `/api/location/${contactLocationID.value}/`;
            const officeBox = document.querySelector('.office-info-contact');
            const officeMap = document.querySelector('.office-map-contact');
            const officeHours = document.querySelector('.opening-hours');
            const officeTourModal = document.querySelector('.office-tour');
            const officeInfo = await fetch(apiURL);
            const officeDetails = await officeInfo.json();

            if (officeDetails.success) {
                const {
                    firmName,
                    directionURL,
                    city,
                    state,
                    zip,
                    location_address_1,
                    location_address_2,
                    phone,
                    email,
                    toll_free_number,
                    location_fax,
                    footer_map,
                    footer_map_mobile,
                    officeTour,
                    monday_hours,
                    tuesday_hours,
                    wednesday_hours,
                    thursday_hours,
                    friday_hours,
                    saturday_hours,
                    sunday_hours,
                    is_spanish,
                } = officeDetails.data;

                const directionLabel = is_spanish ? 'Direcciones' : 'Directions';
                const officeHoursLabel = is_spanish ? 'Horario de Oficina' : 'Office Hours';
                const firmNameHTML = firmName ? `<div class="firm-name">${firmName}</div>` : '';
                const address1HTML = location_address_1 ?
                    `<span>${location_address_1}</span><br>` :
                    '';
                const address2HTML = location_address_2 ?
                    `<span>${location_address_2}</span><br>` :
                    '';
                const phoneHTML = phone ?
                    `<div class="phone"><a href="tel:${phone}" class="btn btn-secondary btn-phone with-icon icon-phone ctm-no-swap" aria-label="${phone}"><span class="text">${phone}</span></a></div>` :
                    '';
                const emailHTML = email ?
                    `<a href="mailto:${email}" aria-label="Email Address">${email}</a>` :
                    '';
                const officeTourHTML = officeTour ? `<button class="cw-modal" data-cw-target="#officeTour" id="office-tour">360 Office Tour</button>` : '';
                const officeInfoButtons = `<div class="office-info__buttons">
                    <a id="directions" href="${directionURL}" target="_blank" aria-label="${directionLabel}">${directionLabel}</a>
                    <button class="cw-modal" data-cw-target="#hoursModal" id="office-hours">${officeHoursLabel}</button>
                    ${officeTourHTML}
                </div>`;

               const footerMapHTML = footer_map ?
                `<a href="${directionURL}" target="_blank" aria-label="Direction Link">
                    <img src="${footer_map_mobile}" alt="${firmName}" />
                </a>` :
                '';

                const address = `${firmNameHTML}
                <address>
                    ${address1HTML}
                    ${address2HTML}
                    <span>${city}, ${state} ${zip}</span><br>
                </address>
               ${phoneHTML}
               ${emailHTML}${officeInfoButtons}`;
               officeBox.innerHTML = address;
               officeMap.innerHTML = footerMapHTML;

                const mondayLabel = is_spanish ? 'Lunes' : 'Monday';
                const tuesdayLabel = is_spanish ? 'Martes' : 'Tuesday';
                const wednesdayLabel = is_spanish ? 'Miércoles' : 'Wednesday';
                const thursdayLabel = is_spanish ? 'Jueves' : 'Thursday';
                const fridayLabel = is_spanish ? 'Viernes' : 'Friday';
                const saturdayLabel = is_spanish ? 'Sábado' : 'Saturday';
                const sundayLabel = is_spanish ? 'Domingo' : 'Sunday';
                const mondayHoursHTML = monday_hours ?
                    `<tr><td class="day">${mondayLabel}</td><td class="time"><span>${monday_hours}</span></td></tr>` :
                    '';
                const tuesdayHoursHTML = tuesday_hours ?
                    `<tr><td class="day">${tuesdayLabel}</td><td class="time"><span>${tuesday_hours}</span></td></tr>` :
                    '';
                const wednesdayHoursHTML = wednesday_hours ?
                    `<tr><td class="day">${wednesdayLabel}</td><td class="time"><span>${wednesday_hours}</span></td></tr>` :
                    '';
                const thursdayHoursHTML = thursday_hours ?
                    `<tr><td class="day">${thursdayLabel}</td><td class="time"><span>${thursday_hours}</span></td></tr>` :
                    '';
                const fridayHoursHTML = friday_hours ?
                    `<tr><td class="day">${fridayLabel}</td><td class="time"><span>${friday_hours}</span></td></tr>` :
                    '';
                const saturdayHoursHTML = saturday_hours ?
                    `<tr><td class="day">${saturdayLabel}</td><td class="time"><span>${saturday_hours}</span></td></tr>` :
                    '';
                const sundayHoursHTML = sunday_hours ?
                    `<tr><td class="day">${sundayLabel}</td><td class="time"><span>${sunday_hours}</span></td></tr>` :
                    '';

                const hoursOffice = `<table>
                                <tbody>
                                ${mondayHoursHTML}
                                ${tuesdayHoursHTML}
                                ${wednesdayHoursHTML}
                                ${thursdayHoursHTML}
                                ${fridayHoursHTML}
                                ${saturdayHoursHTML}
                                ${sundayHoursHTML}
                                </tbody>
                            </table>`;

                // Hours Modal
                officeHours.innerHTML = hoursOffice;

                const officeTourData = `${officeTour}`;
                officeTourModal.innerHTML = officeTourData;
            }
        }
    },

    /**
     * Mobile Menu
     */
    mobileMenu() {
        const mobileButton = document.querySelector('.mobile-button');
        const mobileMenuElement = document.querySelector('#mmenu');
        const mobileChecker = document.querySelector('.mm-ocd');

        if (mobileButton && mobileMenuElement) {
            // Call mmenujs module
            CwLoadModules.mmenu().then((MmenuLight) => {
                if (!mobileChecker) {
                    const menu = new MmenuLight(mobileMenuElement);
                    menu.navigation();
                    const drawer = menu.offcanvas();

                    // Register event for listening to clicks
                    mobileButton.addEventListener('click', () => drawer.open());

                    /**
                     * Close Button
                     */
                    const closeButton = document.querySelector('.close__mobileMenu');

                    closeButton.addEventListener('click', () => drawer.close());

                    /**
                     *  Appending a click option for link tags
                     * with a hash(#) symbol at the beginning of the href
                     * */

                    const aHashTag = mobileMenuElement.querySelectorAll('a[href="#"]');
                    aHashTag.forEach((tag) => {
                        tag.addEventListener('click', (event) => {
                            event.target.parentNode.click();
                            event.preventDefault();
                        });
                    });
                }
            });
        }
    },
};

export default CwThemeFramework;